import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { WorkflowIconDisplayComponent } from '../../../../features/workflows/components/workflow-icon-display/workflow-icon-display.component';

@Component({
  selector: 'app-sidebar-workflow',
  standalone: true,
  imports: [RouterLink, WorkflowIconDisplayComponent],
  templateUrl: './sidebar-workflow.component.html',
  styleUrl: './sidebar-workflow.component.css',
})
export class SidebarWorkflowComponent {
  readonly id = input.required<string>();
  readonly name = input.required<string>();
  readonly route = input.required<string>();
  readonly icon = input<string>('columns-3');
  readonly colorHex = input<string>('#3B82F6');
  readonly isActive = input<boolean>(false);

  /** Igual à lista de workflows: fundo = cor gravada + alpha `20` (8-digit hex). */
  iconBackdropBackground(): string {
    return `${this.safeHex()}20`;
  }

  private safeHex(): string {
    const raw = (this.colorHex() || '#3B82F6').trim();
    return /^#[0-9A-Fa-f]{6}$/i.test(raw)
      ? `#${raw.slice(1).toUpperCase()}`
      : '#3B82F6';
  }
}
